import { isNil } from 'lodash';
import { Plan } from '@mm/state/interfaces/subscription';
import { SubscriptionModel } from '@mm/state/model/SubscriptionModel';

export const getPriceByPhoneNumber = ({
  plan,
  currentSubscription,
  futurePaymentCredits,
}: {
  plan: Plan;
  currentSubscription: SubscriptionModel;
  futurePaymentCredits?: number;
}) => {
  const {
    maxSendAllotment = 0,
    unitAmountInCents = 0,
    sendAllotmentLevel,
    userSeats,
    extraUserSeats,
    smsNumbers = {},
    priceFactor,
    basePrice,
  } = currentSubscription;

  const {
    sendAllotmentAddOnPrice = 0,
    userSeatsAddOnPrice,
    smsNumberAddOnPrice,
  } = plan;

  const currentSendCreditsPrice = sendAllotmentLevel * sendAllotmentAddOnPrice;
  const currentUserSeatsValue = isNil(userSeats) ? -1 : userSeats;

  const currentUserSeatsPrice =
    (userSeatsAddOnPrice || 0) * (extraUserSeats || 0);

  const smsNumberCount = Object.values(smsNumbers).filter(Boolean).length;
  const newSmsNumberCount = smsNumberCount + 1;
  const currentSmsNumberPrice = smsNumberCount * smsNumberAddOnPrice;
  const newSmsNumberPrice = newSmsNumberCount * smsNumberAddOnPrice;

  const newMonthlyFee =
    (plan ? plan.unitAmountInCents / 100 : 0) +
    currentUserSeatsPrice +
    newSmsNumberPrice +
    currentSendCreditsPrice;
  const currentMonthlyFee = unitAmountInCents / 100;
  const proRatedAmount = smsNumberAddOnPrice * priceFactor;

  return {
    planPrice: basePrice,
    newSendCreditsValue: null,
    currentSendCreditsValue: maxSendAllotment,
    currentMonthlyFee,
    currentSendCreditsPrice: null,
    currentUserSeatsValue,
    currentUserSeatsPrice: null,
    newUserSeatsPrice: currentUserSeatsPrice,
    newUserSeatsValue: null,
    newSendCreditsPrice: currentSendCreditsPrice,
    newMonthlyFee,
    payNow: proRatedAmount ? proRatedAmount : smsNumberAddOnPrice,
    smsNumberCount,
    currentSmsNumberPrice,
    newSmsNumberPrice,
    newSmsNumberCount,
    proRatedAmount: proRatedAmount || 0,
    proRatedAsCredit: futurePaymentCredits,
    showAddCoupon: false,
  };
};
